module.exports = __webpack_public_path__ + "static/media/send-letter-info-img4@2x.21761761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img4@2x.png
// module id = 1318
// module chunks = 1